<template>
    <a-tag :color="colorProp">
        <a :href="`/games/${name}`" target="_blank">{{ title }}</a> |
        <a :href="`/tower/?name=${name}`" target="_blank">{{ rate == "0" ? "无评分" : rate }}</a>
    </a-tag>
</template>

<script>
const colors = [
    '', 'orange', 'blue', 'green', 'red', 'purple'
];

export default {
    props: {
        name: String,
        title: String,
        color: String,
        rate: String,
    },
    computed: {
        colorProp() {
            return colors[this.color];
        }
    }
}
</script>

<style>

</style>